/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Settings_Files_Toast_Upload_LoadingInputs */

const es_settings_files_toast_upload_loading = /** @type {(inputs: Settings_Files_Toast_Upload_LoadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Subiendo ${i?.count} archivo(s)…`)
};

const en_settings_files_toast_upload_loading = /** @type {(inputs: Settings_Files_Toast_Upload_LoadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Uploading ${i?.count} file(s)…`)
};

/**
* | output |
* | --- |
* | "Uploading {count} file(s)…" |
*
* @param {Settings_Files_Toast_Upload_LoadingInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_toast_upload_loading = /** @type {((inputs: Settings_Files_Toast_Upload_LoadingInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_Toast_Upload_LoadingInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_toast_upload_loading(inputs)
	return en_settings_files_toast_upload_loading(inputs)
});
export { settings_files_toast_upload_loading as "settings.files.toast.upload_loading" }